import instance from './http.service';

let listController = null;

const TransactionHistoryService = {
  list: (params) => {
    if (listController) listController.abort();
    listController = new AbortController();
    return instance.get('/transactions', {
      params: {
        chain: params.chain,
        walletAddress: params.walletAddress,
        page: params.page ?? 1,
        limit: params.limit ?? 500,
      },
      signal: listController.signal,
    });
  },

  create: (body) => instance.post('/transactions', body),

  update: (id, body) => instance.put(`/transactions/${id}`, body),

  getById: (id) => instance.get(`/transactions/${id}`),
};

export default TransactionHistoryService;
